/*-----------------------*/
/*-----DROPDOWN CART-----*/
/*-----------------------*/

var trashSvg ='<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><title>trash</title><path d="M17 2h-3.5l-1-1h-5l-1 1H3v2h14zM4 17a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5H4z"/></svg>'


  function dropdownCart() {
    
  $.ajax({
	type: 'GET',
	url: '/cart.json',
	dataType: 'json',
	success: function(data) {
      document.getElementById('Bag').innerHTML = "";
      document.getElementById('Bag-head').innerHTML = "";
		var item_count = data['item_count'];
        var total_price = data['total_price']/100;

		//If there are items in cart
		if(item_count > 0) {
			//Display total count and price
			$('#Bag-head').append('<div class="cart_count">'+ item_count +' Items</div><div class="cart_price">Total price : ' + (Math.round(total_price * 100) / 100).toFixed(2) + '€</div>');
            //Display free shipping
            var shippingCost = localStorage.getItem("del_C");
          if (shippingCost >= total_price) {
            $('.free-shipping-count').text(shippingCost - total_price + " € LEFT FOR FREE SHIPPING" );
          } else if (shippingCost < total_price) {
            $('.free-shipping-count').text("FREE SHIPPING !");
          } else {
            $('.free-shipping-count').text("FREE SHIPPING, FREE RETURN*");
          }
			//Display total price on header
            document.getElementById('cartTotalPrice').textContent = "€" + (Math.round(total_price * 100) / 100).toFixed(2);
            document.getElementById('cartTotalCount').textContent = item_count;
            $('.cartCost').removeClass("hidden-count");
            $("#cartItemCountMobile").removeClass('hidden');
            $('#Bag').show();
            $('#Bag-foot').show();

            
			for(var i=0;i<item_count;i++){
				var product_title = data['items'][i]['title'];
              	var id = data['items'][i]['id'];
				var quantity = data['items'][i]['quantity'];
				var line_price = data['items'][i]['line_price']/100;
				var url = data['items'][i]['url'];
				var image = data['items'][i]['image'];
				var image_url = image.substring(0, image.lastIndexOf(".")) + "_100x" + image.substring(image.lastIndexOf("."));
              $('#Bag').append('<li><div class="grid_1_2"><div class="grid_1_1"><a class="dropdown-cart-grid" href="'+ 'http://neo-family.myshopify.com' + url +'"><div class="thumb"><img src="'+ image_url +'"/></div></a></div><div class="grid_2_2"><a class="dropdown-cart-grid" href="'+ 'http://neo-family.myshopify.com' + url +'"><div class="product_description" style="transition: 0.2s;">'+ product_title +'</div></a><div class="grid_1_2">Qty - '+ quantity +' <br/>'+ line_price.toFixed(2) +'€<span class="cart-cross" onclick="removeItem(' + id + ')" >' + trashSvg + '</span></div></div></div></li>');
            }
        } else {
          $('#Bag-head').append('<div class="cart_count">The cart is empty</div>');
          $('#Bag').hide();
          $('#Bag-foot').hide();
          $( ".cartCost" ).addClass( "hidden-count" );

        }
	}
});
}

function addCartAnimation() {
  setTimeout(function() {
    $(".dropdown-cart").addClass("hover-cart");setTimeout(function() {
      $(".dropdown-cart").removeClass("hover-cart");
    }, 3000)
  }, 1000)
};

function removeCartAnimation() {
  $(".cart-cross")
};

$(document).on("click", ".cart-cross", function() {
  item = $(this).closest("li");
  $(item).addClass("dropdown-cart__remove");
})

function removeItem(id) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data:  'quantity='+0+'&id='+id,
    dataType: 'json',
    success: function() {
          dropdownCart();
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
  setTimeout(function() {
    dropdownCart();
  }, 1000)
};

function addItem(variantId) {
  var quantity = quantity || 1,
      params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + 1 + '&id=' +  variantId,
    dataType: 'json',
    success: function() {
      dropdownCart(addCartAnimation);
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    } 
  };
  jQuery.ajax(params);
};

    $(document).on("click", ".caption .switchBox input[type=radio]", function() {
      var container = $(this).closest(".caption")
          , price = container.find("input[type=radio]:checked").attr("item-price")
      	  , product = container.find("input[type=radio]:checked").attr("product")
      	  , title = container.find("inupt[type=radio]:checked").attr("title");
      $("#variantPrice" + product).empty();
      $('<p>€' + (Math.round(price) / 100).toFixed(2) + '</p>').appendTo("#variantPrice" + product);
    });
    

    $(document).on("change", ".caption #productSelect", function() {
	  var container = $(this).closest(".caption")
      	  , price = container.find("option:selected").attr("item-price")
      	  , product = container.find("option:selected").attr("product");
      $("#variantPrice" + product).empty();
      $('<p>€' + (Math.round(price) / 100).toFixed(2) + '</p>').appendTo("#variantPrice" + product);
	});
    
    $(document).on("click", ".spf-product__form .addToCart", function() {
        var container = $(this).closest(".spf-product__form")
          , sku = container.find("option:selected").val()
        addItem(sku);    
    });

  $(document).on("change", ".gf-sort-wrap #sizeType", function() {
  var container = $(this).closest(".sort-by-euukus")
  , euukus = container.find("option:selected").val()
  if (euukus == "eu") {

    $(".sizes1").hide();
    $(".sizes2").hide();
    $(".sizes0").show();
  } else if (euukus == "uk") {
    $(".sizes0").hide();
    $(".sizes2").hide();
    $(".sizes1").show();
  } else {

    $(".sizes0").hide();
    $(".sizes1").hide();
    $(".sizes2").show();
  }
});


/*------------------------*/
/*-----DROPDOWN PANEL-----*/
/*------------------------*/

var prevClick = -1;
function dropPanel(t){
  var acc = document.getElementsByClassName("drop-down");

  for (i = 0; i < acc.length; i++) {  
    if(acc[i] === t){
    	t.classList.toggle("active-drop-down");
      var panel = t.nextElementSibling;
      if(prevClick !== i) {
				panel.style.maxHeight = panel.scrollHeight + "px";
        prevClick = i;
      } else {
      	panel.style.maxHeight = "0px";
        prevClick = -1;
      }
    } else {
    	acc[i].classList.remove("active-drop-down");
      var panel = acc[i].nextElementSibling;
      panel.style.maxHeight = "0px";
    }
  }
}

/*------------------------*/
/*--------SIDE BAR--------*/
/*------------------------*/

/*    if ($(window).width() > 600) {
$(document).on("click", ".header-message", function() {
      $(".sidebar").css("width", "600px");
  $(".main-html").css({"margin-left" : "600px" , "transition" : "margin-left .5s" , "margin-right" : "-600px"});
    });
    
$(document).on("click", ".close-sidebar", function() {
      $(".sidebar").css("width", "0px");
  $(".main-html").css({"margin-left" : "0px" , "margin-right" : "0px"});

    });
    }else{
$(document).on("click", ".header-message", function() {
      $(".sidebar").css("width", $(window).width() + "px");
    });
    
$(document).on("click", ".close-sidebar", function() {
      $(".sidebar").css("width", "0px");

    });
    }*/

//Menu Toggle Hamburger Animation
$(".menu-toggle-btn").click(function() {
  			$(this).toggleClass("open");
  $('.nav--mobile').css('box-shadow', 'rgb(0 0 0 / 20%) 0px 16px 15px -20px');
		});
        
        
        
//FAQ
$(document).on("click", ".faq-subtitle", function() {
  $(".faq-pop").hide();
  $(this).next(".faq-pop").show();
});

$(document).on("click", ".faq-pop svg", function() {
  $(".faq-pop").hide();
});

//Header


function infoBarAnimate() {

var infoBarHeight = $(".info-bar").height() + 5;
var blockMenuHeight = $("#block-menu").height();
  $("#shopify-section-header").css({/*"height" : infoBarHeight + blockMenuHeight + "px" , */"top" : - (infoBarHeight) - 5 + "px"});
}

function logoAnimate() {
  
  var infoBarHeight = $(".info-bar").outerHeight();
  
  if ( $(window).scrollTop() > infoBarHeight ) {
    $('.logo-svg').removeAttr('viewBox');
    $('.logo-svg').each(function () { $(this)[0].setAttribute('viewBox', '250 150 500 500') });
    $('.nav--desktop').css('box-shadow', 'rgb(0 0 0 / 20%) 0px 16px 15px -20px');
    $('.nav--mobile').css('box-shadow', 'rgb(0 0 0 / 20%) 0px 16px 15px -20px');
  } else {
    $('.logo-svg').removeAttr('viewBox');
    $('.logo-svg').each(function () { $(this)[0].setAttribute('viewBox', '250 200 500 500') });
    $('.nav--desktop').css('box-shadow', '');
    $('.nav--mobile').css('box-shadow', '');
  };
  
  if ( $(window).scrollTop() > 0 ) {
    $('.logo-svg_text').css('opacity', '0');
  } else {
    $('.logo-svg_text').css('opacity', '1');
  };
}

function logoPushHeight() {
  var width = $('.logo-push').width();
  
  $('.logo-push').css('height', width + 'px');
}

function translateMegaMenu() {
  var menus = document.getElementsByClassName("gm-text");
  var domain = window.location.hostname;
  var ext = document.location.href.split('/');
    for (var i = 0; i < menus.length; i++) {
      var menu = menus[i].innerHTML.split(' - ');
      if (( domain == 'www.neofamily.fr' || ext[3] == 'fr' ) && typeof menu[1] != 'undefined') {
        menus[i].innerHTML = menu[1];
      } else {
        menus[i].innerHTML = menu[0];
      }
    }
}

$(window).scroll(function() {
  logoAnimate();
});


$( document ).ready(function() {
  $('.gm-target').attr('style', 'padding: 15px 20px 15px 0 !important;');
  $('.gm-mega').css('box-shadow', 'rgb(0 0 0 / 20%) 0px 16px 15px -20px');
  infoBarAnimate();
  logoAnimate();
  logoPushHeight();
  dropdownCart();
});

document.addEventListener('DOMContentLoaded', function(event) {
  setTimeout(translateMegaMenu, 2000)
})

window.onload = function() {
  collectionFilterName();
};


$( window ).resize(function() {
  infoBarAnimate();
  logoAnimate();
  logoPushHeight();
});

//Delivery pannel toggle
function searchBarAppear() {
  $(".search-bar-header").css({"display": "flex", "opacity": "1"});
}

function searchBarClose() {
  $(".search-bar-header").css({"display": "none", "opacity": "0"});
}

function collectionFilterName() {
  var filter = $(".selected-items").text();

}

function vpMegaMenu() {
  $( ".mega-menu--mobile.header-menu" ).append( "<li class='gm-item gm-level-0'><a href='/collections/vpss21' class='gm-target  js-no-transition' style='padding: 15px 20px 15px 0 !important;'><span class='gm-text' style='color: red !important;'>VP</span></a></li>" );
  $( ".mega-menu.header-menu" ).append( "<li class='gm-item gm-level-0'><a href='/collections/vpss21' class='gm-target  js-no-transition' style='padding: 15px 20px 15px 0 !important;'><span class='gm-text' style='color: red !important;'>VP</span></a></li>" );
}

//size-guide toggle
$(".js-toggle-size-guide").on("click", function () {
    $(".pannel.size-guide").addClass("active");
    $(".fixed-back").addClass("active");
    $("body").addClass("no-overflow");
    $("#productInfo-product").css({"position":"relative"});
});
$(".close-size-guide").on("click", function () {
    $(".pannel.size-guide").removeClass("active");
    $(".fixed-back").removeClass("active");
    $("body").removeClass("no-overflow");
    $("#productInfo-product").css({"position":"sticky"});
});


$(".product-size-selector").on("click", () => {
    $(".product-size-options").toggleClass("visible-size-options");
    $(".product-size-selector").toggleClass("bottom-border");
    $(".product-size-selector").toggleClass("active");
})

$(".product-size-options").on("click", (el) => {
    $(".product-size-options").removeClass("visible-size-options");
    $(".product-size-selector").removeClass("bottom-border");
    $(".product-size-selector").removeClass("active");
    var selectedSize = $('input[name="sizeSelect"]:checked').attr('data');
    //var properSize = selectedSize.substring(0, selectedSize.indexOf(" - "));
    $('.selected-size').text(selectedSize)
});

$(function(){
    $('.image-zoom').each(function() {
        var original_img_url = $(this).attr('data-zoom');
        $(this)
        .parent()
        .zoom({url: original_img_url});
    });
});